import styled from 'styled-components'

export const GoogleLoginButtonBase = styled.div`
  width: 100%;
  text-align: center;
  margin-block-start: -40px;
  margin-block-end: 30px;
`

export const CustomButton = styled.button`
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  border: 2px solid ${props => props.theme.colors.grey1};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.grey8};
  cursor: pointer;
  &:hover {
    background-color: ${props => props.theme.colors.grey6};
  }
  div {
    display: flex;
    padding-block: 0;
    padding-inline: 0;
    margin-inline-end: 8px;
    background-color: transparent;
    svg {
      width: 20px;
      height: 20px;
    }
  }

  span {
    font-family: ${props => props.theme.fonts.families.primary};
    font-size: 16px;
    font-weight: 900;
    color: ${props => props.theme.colors.grey1};
    line-height: 24px;
    padding-block: 12px;
    padding-inline: 0;
  }
`
